module.exports = __webpack_public_path__ + "static/media/43.2cb8a37c.png";